<template>
    <div class='component-page'>
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                <span>时间：</span>
                <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                <span style="margin: 0 10px;">至</span>
                <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <Col span="2" style="float:right">
                <i-button type="primary" icon="md-add" shape="circle" @click="add_new">添加</i-button>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
            <Modal v-model="addModel" width="720" :title="modalTitle">
                <div v-if='addModel'>
                    <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                        <Row>
                            <Col span="11">
                                <FormItem label="学生" prop='user_id'>
                                    <Select filterable v-model="formData.user_id" style='width:300px;' clearable>
                                        <Option v-for="item in userList" :value="item.user_id" :key="item.user_id">{{ item.nickname }}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span="11" style='float:right'>
                                <FormItem label="评语" prop='content'>
                                    <Input v-model="formData.content" type='textarea' placeholder="请输入..."></Input>
                                </FormItem>
                            </Col>
                        </Row>
                     
                        <Row v-if='addModel'>
                            <FormItem label="封面图" prop="cover_url">
                                <UploadImg @getPicList="getPicList" :getList='formData.cover_url' message='1' id='img'></UploadImg>
                            </FormItem>
                        </Row>
                        <Row v-if='addModel'>
                            <FormItem label="视频" prop="video_url">
                                <UploadVideo @getVideos="getVideos" :getVideourl='formData.video_url' message='1'></UploadVideo>
                            </FormItem>
                        </Row>
                       
                    </Form>
                </div>
                <div slot="footer">
                    <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
                    <Button type="primary" shape="circle" @click="save('formData')">确定</Button>
                </div>
            </Modal>
           
        </div>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>


<script>
    import moment from 'moment'
    import {
        fetchTableList,
        setAdd,
        fetchInfo,
        setModify,
       
    } from '@/api/studentMien'
    import {
        fetchUserList,
    } from '@/api/common'
    
    import UploadVideo from '../common/videos.vue'
    import UploadImg from '../common/picture.vue'
    
    export default {
        name: 'user-components',
        components: {
            UploadVideo,
            UploadImg

        },
        data() {
            return {
                total_count: 0, //列表总条数
                formItem: {
                    page: 1, //列表当前页数
                    page_size: 10,
                    type: 2,
                    start_time: '',
                    end_time: '',
                },
                start_time: '',
                end_time: '',
                live_id: '',
                modalTitle: '新增',
                remindModal: false,
                addModel: false, //添加老师
                formData: {
                    live_id: '',
                    teacher_id: '',
                    video_name: '',
                    video_url: '',
                    cover_url:'',
                    type: 2,
                    is_vip: '',
                    flag:'',
                    sort:'',
                },
                userList: [],
                remindContent: '',
                verificationRule: {
                    user_id: [{
                        required: true,
                        message: '不能为空'
                    }],
                    content: [{
                        required: true,
                        message: '不能为空'
                    }],
                   
    
                }, //
                editIncellColumns: [{
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
    
                    },
                    {
                        title: '昵称',
                        align: 'center',
                        key: 'nickname',
                    },
                    {
                        title: '头像',
                        align: 'center',
                        key: 'head_img',
                        width: 100,
                        render: (h, params) => {
                            return h("img", {
                                attrs: {
                                    src: params.row.head_img
                                },
                                style: {
                                    width: '60px',
                                    height: '60px',
                                    marginTop: '4px'
                                }
                            })  
                            
                        }
                    },
                    {
                        title: '校区',
                        align: 'center',
                        key: 'school',
                    },
                    {
                        title: '班级',
                        align: 'center',
                        key: 'class',
                    },
                     {
                        title: '评语',
                        align: 'center',
                        key: 'content',
                    },
                    {
                        title: '视频',
                        align: 'center',
                        key: 'video_url',
                        width: 100,
                        render: (h, params) => {
                            return h("video", {
                                attrs: {
                                    src: params.row.video_url
                                },
                                style: {
                                    width: '60px',
                                    height: '60px',
                                    marginTop: '4px'
                                }
                            })  
                            
                        }
                    },
                   
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        
                        render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
    
                                        },
                                        style: {
                                            marginRight: '10px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.id)
                                            }
                                        }
                                    }, '编辑'),
                                
                                ])
                          
                               
                           
    
                        }
                    },
    
                ], //列表标题
    
                editIncellData: [], //列表数据
    
            };
        },
        methods: {
            //获取列表数据
            getData() {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res = res.data;
                    this.$Loading.finish();
                    if (res.code == 200) {
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            //   this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            getUserList(){
                fetchUserList().then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.userList = res.data;
    
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })

            },
           
            // 添加
            add_new() {
                this.formData.id = '';
                this.formData.user_id = '';
                this.formData.content = '';
                this.formData.cover_url = '';
              
                this.formData.video_url = '';
               
                this.modalTitle = '新增';
                this.addModel = true;
            },
            
            // 修改
            edit(id) {
                fetchInfo({
                    id: id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.modalTitle = '修改';
                        this.formData = res.data;
                        this.formData.id=id;
                        this.addModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(responese.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            // 保存新增和修改
            save(name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        if(this.formData.id != ''){
                            setModify(this.formData).then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    this.getData();
                                    this.addModel = false;
                                } else if (res.code == 14001) {
                                    this.$Message.error(res.msg)
                                    this.$store.dispatch('handleLogOut').then(res => {
                                        this.$store.commit('clearOpenedSubmenu')
                                        this.$router.push({
                                            name: 'login'
                                        })
                                    })
                                } else {
                                    this.$Message.error(res.msg)
                                }
                            })
                        }else{
                            setAdd(this.formData).then(res => {
                                res = res.data;
                                if (res.code == 200) {
                                    this.getData();
                                    this.addModel = false;
                                } else if (res.code == 14001) {
                                    this.$Message.error(res.msg)
                                    this.$store.dispatch('handleLogOut').then(res => {
                                        this.$store.commit('clearOpenedSubmenu')
                                        this.$router.push({
                                            name: 'login'
                                        })
                                    })
                                } else {
                                    this.$Message.error(res.msg)
                                }
                            })
                        }
                        
    
                    }
                })
            },
           
           
            getPicList(picList) {
                this.formData.cover_url = picList[0].url.split('.com')[1];
            },
            getVideos(picList) {
                this.formData.video_url = picList[0].url.split('.com')[1];
            },
            cancel() {
                this.remindModal = false;
    
                this.addModel = false;
    
            },
            // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
    
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            //搜索框搜索
            handleSearch() {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage(row) {
                this.formItem.page = row;
                this.getData();
            },
            //跳转制定页码
            jumpPage(row) {
                this.formItem.page = row;
                this.getData();
            },
            //改变每页条数
            changePageSize(row) {
                this.formItem.page_size = row;
                this.formItem.page = 1;
                this.getData();
            }
    
        },
        mounted() {
            this.getData();
            this.getUserList();
    
        },
    };
</script>
